var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge bg-dark color-white mr-10"},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.startDate,'DD.MM.YYYY'))+" - "),[_vm._v(_vm._s(_vm._f("formatDate")(_vm.endDate,'DD.MM.YYYY')))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }